
<div class="form-group col-md-12 col-xs-12 margin-bottom-0px " *ngIf=" (mode !== 'view' && mode !== 'view2') || mode=='mode'">
  <div class="row  row-for-levels" *ngIf="field">
    <div class="col-md-3 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color"> {{field.Title}}</label>
    </div>
    <!--<div class="col-md-1 padding-left-0px padding-right-0px text-align-center">


      <input type="checkbox" class="width-15px background-2" [(ngModel)]="field.Value" name="field.Value">






    </div>-->
    <div class="col-md-8 display-inherit display-input label-padding-left-10px label-padding-top-2px">
      <!--<label>{{field.Value}}</label>-->
      <!--<input type="text" class="form-control" [(ngModel)]="field.Remarks" [ngModelOptions]="{standalone: true}"/>-->
      <input type="checkbox" class="width-18px background-2" [(ngModel)]="isChecked" [ngModelOptions]="{standalone: true}">
      <!--<textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" rows="2" placeholder="Remarks"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="field.Remarks" maxlength="100"></textarea>-->

      <input class="form-control remarks" [(ngModel)]="field.Remarks" type="text" [ngModelOptions]="{standalone: true}" />



    </div>
  </div>

  <div class="row " *ngIf="field && isChecked && Data && Data.HasChildren">

    <auto-gen-children class="col-md-12" [Data]="Data" [field]="Data.Data"
                       [mode]="mode"></auto-gen-children>

  </div>

</div>
<div class="form-group col-md-12 col-xs-12 margin-bottom-0px " *ngIf="mode=='view' && isChecked">
  <div class="row  row-for-levels" *ngIf="field ">
    <div class="col-md-4 text-align-left label-padding-left-10px" >
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color" > {{field.Title}}</label>
    </div>
    <!--<div class="col-md-1 font-weight-bold margin-top-5px padding-left-0px padding-right-0px">:</div>-->
    <!--<div class="col-md-1 padding-left-0px padding-right-0px text-align-center">


      <input type="checkbox" class="width-15px background-2" [(ngModel)]="field.Value" name="field.Value">






    </div>-->
    <div class="col-md-7 display-inherit display-input label-padding-left-10px label-padding-top-2px" >
      <!--<label>{{field.Value}}</label>-->
      <!--<input type="text" class="form-control" [(ngModel)]="field.Remarks" [ngModelOptions]="{standalone: true}"/>-->
      <!--<input type="checkbox" class="width-18px background-2" [(ngModel)]="field.Value" name="field.Value">-->
      <!--<textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" rows="2" placeholder="Remarks"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="field.Remarks" maxlength="100"></textarea>-->
      <!--<input class="form-control remarks" [(ngModel)]="field.Remarks" type="text" [ngModelOptions]="{standalone: true}" />-->

      <!--<label class="margin-bottom-0px margin-top-5px font-weight-normal" ng-hide="field.Remarks==''"><i>({{field.Remarks}})</i></label>-->
      <label class="margin-bottom-0px margin-top-5px font-weight-normal" *ngIf="field.Remarks!=null"><i>(Comments:{{field.Remarks}})</i></label>
    </div>
  </div>

  <div class="row " *ngIf="field  &&  Data  && Data.HasChildren && isChecked">

    <auto-gen-children class="col-md-12" [Data]="Data" [field]="Data.Data"
                       [mode]="mode"></auto-gen-children>

  </div>

</div>

<div class="form-group col-md-12 col-xs-12 margin-bottom-0px " *ngIf="mode=='view2' && isChecked ">
  <div class="row  row-for-levels font-size-14" *ngIf="field ">
    <div class="col-md-5 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color"> {{field.Title}}</label>
    </div>
    <!--<div class="col-md-1 font-weight-bold margin-top-5px padding-left-0px padding-right-0px">:</div>-->
    <!--<div class="col-md-1 padding-left-0px padding-right-0px text-align-center">


      <input type="checkbox" class="width-15px background-2" [(ngModel)]="field.Value" name="field.Value">






    </div>-->
    <div class="col-md-5 display-inherit display-input label-padding-left-10px label-padding-top-2px">
      <!--<label>{{field.Value}}</label>-->
      <!--<input type="text" class="form-control" [(ngModel)]="field.Remarks" [ngModelOptions]="{standalone: true}"/>-->
      <!--<input type="checkbox" class="width-18px background-2" [(ngModel)]="field.Value" name="field.Value">-->
      <!--<textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" rows="2" placeholder="Remarks"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="field.Remarks" maxlength="100"></textarea>-->
      <!--<input class="form-control remarks" [(ngModel)]="field.Remarks" type="text" [ngModelOptions]="{standalone: true}" />-->
      <!--<label class="margin-bottom-0px margin-top-5px font-weight-normal" ng-hide="field.Remarks==''"><i>({{field.Remarks}})</i></label>-->
      <label class="margin-bottom-0px margin-top-5px font-weight-normal" *ngIf="field.Remarks!=null"><i>(Comments:{{field.Remarks}})</i></label>
    </div>
  </div>

  <div class="row " *ngIf="field  &&  Data  && Data.HasChildren && isChecked">

    <auto-gen-children class="col-md-12" [Data]="Data" [field]="Data.Data"
                       [mode]="mode"></auto-gen-children>

  </div>

</div>
